import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { GetTagsActivityLog } from '../../store/tags.action';


@Component({
  selector: 'app-tags-activity',
  templateUrl: './tags-activity.component.html',
  styleUrls: ['./tags-activity.component.scss']
})
export class TagsActivityComponent implements OnInit {

  tagLogs;
  activityLog = [];

  constructor(
    public location: Location,
    private store: Store<AppState>,
  ) { }

  ngOnInit() {
    this.store.dispatch(new GetTagsActivityLog());
    this.store.select(state => state.tags.tagsLogs).pipe().subscribe(response => {
      this.tagLogs = response;
     });
  }

  onCancel(){
    this.location.back();
  }

}
